import { c as _c } from "react/compiler-runtime";
import { useKeyPressEvent } from 'react-use';
import { isEscKey } from '../helpers/keys';
const useOnEsc = (isEnabled, callback) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== callback || $[1] !== isEnabled) {
    t0 = () => {
      if (isEnabled && callback) {
        callback();
      }
    };
    $[0] = callback;
    $[1] = isEnabled;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useKeyPressEvent(isEscKey, t0);
};
export default useOnEsc;